export class QueryResultsModel {
  // fields
  items: any[];
  totalCount: number;
  errorMessage: string;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(_items: any[] = [], _totalCount = 0, _errorMessage = '') {
    this.items = _items;
    this.totalCount = _totalCount;
  }
}
